var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('div',{staticClass:"connection-status",class:_vm.message.className},[_vm._v(" "+_vm._s(_vm.message.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }